import {observer} from "mobx-react";
import React, {useContext} from "react";
import OrderSettingsPageStoreContext from "../context";
import {Button, FormControl, Paper, Typography} from "../../../../../common/components/libs";
import {FormControlLabel, InputAdornment, InputLabel, Switch} from "@material-ui/core";
import {changeCheckboxEventHandlerDecorator, changeEventHandlerDecorator} from "../../../../../common/libs";
import {useTranslation} from "react-i18next";
import LocalizedInput from "../../../../../common/components/translation/LocalizedInput";
import {MenuType} from "../../../../../services/menu/models";
import {useStores} from '../../../../../hooks';
import Input from '@material-ui/core/Input';

const GeneralInfoBlock = (props) => {
    const {t} = useTranslation(["general", "menu"]);
    const {authStore} = useStores()
    const store = useContext(OrderSettingsPageStoreContext);
    const menuType = store.menuType;

    return <>
        <Typography variant={"h3"} mb={2}>
            {t("menu:orderSettingsPage.commonInformation")}
        </Typography>
        <Paper p={5} style={{maxWidth: 800, width: "100%"}}>
            <LocalizedInput
                label={t("general:name")}
                value={store.current.data.name}
                setNewValue={store.setNewName.bind(store)}
            />
            <LocalizedInput
                label={t("general:description")}
                value={store.current.data.description}
                setNewValue={store.setNewDescription.bind(store)}
                numberOfLines={5}
            />
            <LocalizedInput
                label={t("menu:orderSettingsPage.region")}
                value={store.current.data.addressDetails.region}
                setNewValue={store.setNewAddressRegion.bind(store)}
            />
            <LocalizedInput
                label={t("menu:orderSettingsPage.address")}
                value={store.current.data.addressDetails.title}
                setNewValue={store.setNewAddressTitle.bind(store)}
            />
        </Paper>

        <Paper p={5} style={{maxWidth: 800, width: "100%"}} mt={5}>
            <Typography variant="h6" mt={0}>
                {t("menu:orderSettingsPage.isMenuEnabled.title")}
            </Typography>
            <Typography variant="body2" color={'textSecondary'} mt={0}>
                {t("menu:orderSettingsPage.isMenuEnabled.description")}
            </Typography>
            <FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={store.isMenuEnabled && authStore.isSimpleFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isSimpleFeaturesActive()) {
                                        store.openTariffPromptForm('Simple')
                                    } else {
                                        store.setIsMenuEnabled(v);
                                    }
                                }
                            )}
                            value={store.isMenuEnabled}
                        />
                    }
                    label={t("general:include")}
                />
            </FormControl>
        </Paper>

        <Paper p={5} style={{maxWidth: 800, width: "100%"}} mt={5}>
            <Typography variant="h6" mt={0}>
                {t("menu:orderSettingsPage.isOrderCreationEnabled.title")}
            </Typography>
            <Typography variant="body2" color={'textSecondary'} mt={0}>
                {t("menu:orderSettingsPage.isOrderCreationEnabled.description")}
            </Typography>
            <FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={store.isOrderCreationEnabled && authStore.isBasicFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isBasicFeaturesActive()) {
                                        store.openTariffPromptForm('Basic')
                                    } else {
                                        store.setIsOrderCreationEnabled(v);
                                    }
                                }
                            )}
                            value={store.isOrderCreationEnabled}
                        />
                    }
                    label={t("general:include")}
                />
            </FormControl>
        </Paper>

        <Paper p={5} style={{maxWidth: 800, width: "100%"}} mt={5}>
            <Typography variant="h6" mt={0}>
                {t("menu:orderSettingsPage.isPromocodeEnabled.title")}
            </Typography>
            <Typography variant="body2" color={'textSecondary'} mt={0}>
                {t("menu:orderSettingsPage.isPromocodeEnabled.description")}
            </Typography>
            <FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={store.isPromoCodesEnabled && authStore.isBasicFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isBasicFeaturesActive()) {
                                        store.openTariffPromptForm('Basic')
                                    } else {
                                        store.setIsPromocodesEnabled(v);
                                    }
                                }
                            )}
                            value={store.isOrderCreationEnabled}
                        />
                    }
                    label={t("general:include")}
                />
            </FormControl>
        </Paper>


        {/*<Paper p={5} style={{ maxWidth: 800, width: "100%" }} mt={5}>
            <Typography variant="h6" mt={0}>
                {t("menu:orderSettingsPage.isFeedbackEnabled.title")}
            </Typography>
            <Typography variant="body2" color={'textSecondary'} mt={0}>
                {t("menu:orderSettingsPage.isFeedbackEnabled.description")}
            </Typography>
            <FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={store.isFeedbackEnabled}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    store.setIsFeedbackEnabled(v);
                                }
                            )}
                            value={store.isFeedbackEnabled}
                        />
                    }
                    label={t("general:include")}
                />
            </FormControl>
        </Paper>*/}
        {
            menuType === MenuType.regular &&
            <Paper p={5} style={{maxWidth: 800, width: "100%"}} mt={5}>
                <Typography variant="h6" mt={0}>
                    {t("menu:orderSettingsPage.isLoyalProgramEnabled.title")}
                </Typography>
                <Typography variant="body2" color={'textSecondary'} mt={0}>
                    {t("menu:orderSettingsPage.isLoyalProgramEnabled.description")}
                </Typography>
                <FormControl>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={store.isLoyalProgramEnabled && authStore.isBasicFeaturesActive()}
                                onChange={changeCheckboxEventHandlerDecorator(
                                    (v: boolean) => {
                                        if (!authStore.isBasicFeaturesActive()) {
                                            store.openTariffPromptForm('Basic')
                                        } else {
                                            store.setIsLoyalProgramEnabled(v);
                                        }
                                    }
                                )}
                                value={store.isLoyalProgramEnabled}
                            />
                        }
                        label={t("general:include")}
                    />
                </FormControl>
            </Paper>
        }


        {menuType === MenuType.regular && <Paper p={5} style={{maxWidth: 800, width: "100%"}} mt={5}>
            <Typography variant="h6" mt={0}>
                {t("menu:waiterCall")}
            </Typography>
            <Typography variant="body2" color={'textSecondary'} mt={0}>
                {t("menu:editingWaiterCall")}
            </Typography>
            <FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={store.isWaiterCallEnabled && authStore.isSimpleFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isSimpleFeaturesActive()) {
                                        store.openTariffPromptForm('Simple')
                                    } else {
                                        store.setIsWaiterCallEnabled(v);
                                    }
                                }
                            )}
                            value={store.isWaiterCallEnabled}
                        />
                    }
                    label={t("general:include")}
                />
            </FormControl>
            <Button color="primary"
                    onClick={props.scroll}
                    disabled={!authStore.isSimpleFeaturesActive()}
            >
                {t("menu:orderSettingsPage.editNotifications")}
            </Button>

        </Paper>}

        <Paper p={5} style={{maxWidth: 800, width: "100%"}} mt={5}>
            <Typography variant="h6" mt={0}>
                Информационный поп-ап
            </Typography>
            <Typography variant="body2" color={'textSecondary'} mt={0}>
                Настройте информационное сообщение, которое гость будет видеть при открытии меню
            </Typography>
            <FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            checked={store.current.data.infoMessages[0].isEnabled && authStore.isSimpleFeaturesActive()}
                            onChange={changeCheckboxEventHandlerDecorator(
                                (v: boolean) => {
                                    if (!authStore.isSimpleFeaturesActive()) {
                                        store.openTariffPromptForm('Simple')
                                    } else {
                                        store.setInfoMessageEnabled(v);
                                    }
                                }
                            )}
                            value={store.isWaiterCallEnabled}
                        />
                    }
                    label={t("general:include")}
                />
            </FormControl>
            {store.current.data.infoMessages[0].isEnabled && (
                <>
                    <LocalizedInput
                        label={'Заголовок'}
                        value={store.current.data.infoMessages[0].title}
                        setNewValue={store.setNewInfoMessageTitle.bind(store)}
                    />
                    <LocalizedInput
                        label={'Описание'}
                        value={store.current.data.infoMessages[0].description}
                        setNewValue={store.setNewInfoMessageDescription.bind(store)}
                    />
                    <LocalizedInput
                        label={'Текст кнопки'}
                        value={store.current.data.infoMessages[0].callToAction}
                        setNewValue={store.setNewInfoMessageCallToAction.bind(store)}
                    />
                    <FormControl fullWidth marginTop={2}>
                        <InputLabel>Ссылка на изображение или GIF</InputLabel>
                        <Input
                            value={store.current.data.infoMessages[0].mediaItems[0].url}
                            onChange={changeEventHandlerDecorator((url) => {
                                store.setNewInfoMessageMediaUrl(url)
                            })}
                        />
                    </FormControl>
                </>
            )}
        </Paper>
    </>

}

export default observer(GeneralInfoBlock)
